import React, { useEffect, useState } from "react";
import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";
import {
  Close,
  DeleteOutline,
  OpenInNew,
  ZoomIn,
  ZoomOut,
} from "@mui/icons-material";
import { colors } from "../../theme/theme";
import DocumentFilePreview from "./DocumentFilePreview";

const DocumentViewerModal = ({ open, onClose, document, onDelete }) => {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    if (open) setZoom(1);
  }, [open]);

  const handleClose = () => {
    setZoom(1);
    onClose();
  };

  if (!document) return null;

  const hasCover = Boolean(document.cover_url);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.9)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ p: 2 }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-SemiBold",
              fontSize: "16px",
            }}
          >
            {document.title}
          </Typography>
          <Stack direction="row" spacing={1}>
            {hasCover && (
              <>
                <IconButton
                  onClick={() => setZoom((z) => Math.max(z - 0.25, 0.5))}
                >
                  <ZoomOut sx={{ color: "#fff" }} />
                </IconButton>
                <IconButton
                  onClick={() => setZoom((z) => Math.min(z + 0.25, 3))}
                >
                  <ZoomIn sx={{ color: "#fff" }} />
                </IconButton>
              </>
            )}
            {document.file_url && (
              <IconButton
                component="a"
                href={document.file_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <OpenInNew sx={{ color: "#fff" }} />
              </IconButton>
            )}
            {onDelete && (
              <IconButton onClick={onDelete}>
                <DeleteOutline sx={{ color: colors.secondary }} />
              </IconButton>
            )}
            <IconButton onClick={handleClose}>
              <Close sx={{ color: "#fff" }} />
            </IconButton>
          </Stack>
        </Stack>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "auto",
            p: 3,
          }}
        >
          {hasCover ? (
            <Box
              component="img"
              src={document.cover_url}
              alt={document.title}
              sx={{
                maxWidth: "90%",
                maxHeight: "80vh",
                transform: `scale(${zoom})`,
                transition: "transform 0.2s ease",
                objectFit: "contain",
              }}
            />
          ) : (
            <Box sx={{ textAlign: "center", width: "260px" }}>
              <DocumentFilePreview
                fileName={document.file_name}
                height="220px"
                iconSize="64px"
              />
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  fontFamily: "Mulish-Regular",
                  fontSize: "13px",
                  mt: 2,
                }}
              >
                {document.file_name}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default DocumentViewerModal;
